import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/sagas/utilization";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";

export const GroupObjectsFilter = () => {
  const dispatch = useDispatch();

  const averageGroup = useSelector((state) => state.utilization.averageGroup);
  const subAverageFilterOptions = useSelector((state) => state.utilization.subAverageFilterOptions);
  const selectedSubAverageFilterOptions = useSelector(
    (state) => state.utilization.selectedSubAverageFilterOptions
  );

  if (!subAverageFilterOptions[averageGroup]?.length) return null;

  return (
    <div className="select-box" style={{ width: "150px" }}>
      <p className="offers-title">{averageGroup}</p>
      <MultiSelectDropdown
        options={subAverageFilterOptions[averageGroup]}
        selectedFilters={selectedSubAverageFilterOptions}
        onSelectChange={(data) => dispatch(actionCreators.setSubAverageSelectedOptions(data))}
        enableOnly
        numberDisplayed={0}
        includeSelectAll
        haveOnSelectChange
      />
    </div>
  );
};
